export default __webpack_public_path__ + "static/media/acan.74d4c471.png";